export interface NotificationData {
  flow_id: number;
  step_id: number;
  comment_id?: number;
  record_id?: number;
  project_id?: number;
  delegation_id?: number;
  delegator_id?: number;
  background_task_id?: number;
}

export interface NotificationTypeRef {
  value: string;
  label: string;
}

export interface Notification {
  id: number;
  notification_type: NotificationTypeRef;
  /** Configured title (current language) for workflow reflections, otherwise the type label. */
  title?: string;
  message: string;
  data: NotificationData;
  read_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface NotificationResponse {
  data: Notification[];
  links: {
    first: string | null;
    last: string | null;
    prev: string | null;
    next: string | null;
  };
  meta: {
    path: string;
    per_page: number;
    next_cursor: string | null;
    prev_cursor: string | null;
  };
}

export enum NotificationTypeValue {
  SLA_TIME_NOTIFICATION = 'sla_time_notification',
  ESCALATION = 'escalation',
  NEW_TASK_ASSIGNED = 'new_task_assigned',
  COMPILATION = 'compilation',
  COLLABORATION = 'collaborator_added',
  SLA_REACHED = 'sla_reached',
  COMMENT_MENTION = 'comment_mention',
  ON_HOLD = 'request_on_hold',
  RESUMED = 'request_resumed',
  REQUEST_UPDATED = 'request_updated',
  COMMENT_REACTION = 'comment_reaction',
  CONTRIBUTOR_ADDED = 'contributor_added',
  CONTRIBUTOR_SUBMITTED_DATA = 'contributor_submitted_data',
  DELEGATION_ACTIVATED = 'delegation_activated',
  UPCOMING_DELEGATION = 'upcoming_delegation',
  BORROWING_CREATED = 'borrowing_created',
  BORROWING_UPDATED = 'borrowing_updated',
  TIME_DEPOSIT_CREATED = 'time_deposit_created',
  TIME_DEPOSIT_UPDATED = 'time_deposit_updated',
  WORKFLOW_REFLECTION = 'workflow_reflection',
  BACKGROUND_TASK_RECEIVED = 'background_task_received',
  BACKGROUND_TASK_COMPLETED = 'background_task_completed',
  BACKGROUND_TASK_FAILED = 'background_task_failed',
}

export enum NotificationChannelValue {
  IN_APP = 'in_app',
  MAIL = 'mail',
}

export enum NotificationFilterTab {
  ALL = 'all',
  UNREAD = 'unread',
}

export interface NotificationType {
  value: string;
  label: string;
  channels: NotificationChannel[];
  has_preferences: boolean;
  default_preferences: number | null;
}

export interface NotificationChannel {
  value: string;
  label: string;
}

export interface NotificationTypesResponse {
  data: NotificationType[];
}
